const MainPanel = () => import('@/components/admin/MainPanel');
const DialogList = () => import('@/components/admin/DialogList');
const DialogBuilder = () => import('@/components/admin/DialogBuilder');
const SalesPanel = () => import('@/components/admin/SalesPanel');

export default [
  {
    path: '/panel',
    component: MainPanel,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/panel/dialogs',
    component: DialogList,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/panel/dialog_builder',
    component: DialogBuilder,
    meta: {
      layout: 'InsightsLayout',
    },
  },
  {
    path: '/panel/sales',
    component: SalesPanel,
    meta: {
      layout: 'InsightsLayout',
    },
  },
];
